export const GA_MEASUREMENT_ID = 'G-CERDRDLWCC';

type AnalyticsValue = string | number | boolean | undefined;
type AnalyticsParameters = Record<string, AnalyticsValue>;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function trackEvent(eventName: string, parameters: AnalyticsParameters = {}): void {
  if (typeof window === 'undefined' || !window.gtag) return;

  const cleanParameters = Object.fromEntries(
    Object.entries(parameters).filter(([, value]) => value !== undefined)
  );
  window.gtag('event', eventName, cleanParameters);
}

export function trackPageView(parameters: {
  pageTitle: string;
  pageLocation: string;
  pagePath: string;
  language: string;
}): void {
  trackEvent('page_view', {
    page_title: parameters.pageTitle,
    page_location: parameters.pageLocation,
    page_path: parameters.pagePath,
    language: parameters.language,
  });
}
